var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us-page"},[_c('Typeform',{attrs:{"url":"https://sungod.typeform.com/to/wDCIHW","hide-headers":true,"hide-footer":true,"button-text":"Contact Us","opacity":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }